module.exports = __webpack_public_path__ + "img/img7.5cf3cab3.png";